import { Text } from '@pasqal/core/ui/components';
import afmocImg from '~/assets/images/afm-oc.webp';
import afmImg from '~/assets/images/afm.webp';
import czImg from '~/assets/images/cz.webp';
import Card from '../ui/Card/Card';
import './ExampleGallery.css';

interface ExampleGalleryProps {
  onLoadExample: (id: string) => void;
}

type Example = {
  id: string;
  name: string;
  description: string;
  image: string;
};

const examples: Example[] = [
  {
    id: 'afm',
    name: 'AFM state preparation',
    description: 'Anti-ferromagnetic state preparation in the Ising model.',
    image: afmImg
  },
  {
    id: 'afm-optimal-control',
    name: 'AFM state preparation with an optimal pulse',
    description:
      'Anti-ferromagnetic state preparation using a pulse designed with an optimal control method.',
    image: afmocImg
  },
  {
    id: 'cz',
    name: 'Control-Z gate',
    description: 'Control-Z gate',
    image: czImg
  }
];

export default function ExampleGallery({ onLoadExample }: ExampleGalleryProps) {
  return (
    <ul className="ExampleGallery u-scrollbarDark">
      {examples.map((example) => (
        <Card
          key={example.id}
          as="li"
          className="ExampleGallery-card"
          onClick={() => onLoadExample(example.id)}
        >
          <div className="ExampleGallery-image">
            <img src={example.image} alt="" />
          </div>
          <div className="ExampleGallery-desc">
            <Text as="h3" font="medium">
              {example.name}
            </Text>
            <Text as="p" color="neutral-secondary">
              {example.description}
            </Text>
          </div>
        </Card>
      ))}
    </ul>
  );
}
